import { createContext, useContext, ReactNode } from 'react';

const ConvexAvailableContext = createContext(false);

export function ConvexAvailableProvider({
  value,
  children,
}: {
  value: boolean;
  children: ReactNode;
}) {
  return (
    <ConvexAvailableContext.Provider value={value}>
      {children}
    </ConvexAvailableContext.Provider>
  );
}

export function useConvexAvailable(): boolean {
  return useContext(ConvexAvailableContext);
}
